import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice holding the OIDC auth token, loading state, and last auth error.
 */
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
    isLoading: false,
    error: null
  },
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload
      state.error = null
    },
    clearAuthToken: state => {
      state.token = null
    },
    setAuthError: (state, action) => {
      state.error = action.payload
    }
  }
})

/**
 * `setAuthToken` stores the token and clears any error; `clearAuthToken` resets it to `null`;
 * `setAuthError` records the last auth error.
 */
export const { setAuthToken, clearAuthToken, setAuthError } = authSlice.actions

/**
 * Auth slice reducer, registered under the `auth` key of the Redux store.
 */
export default authSlice.reducer
